<template>
  <div class="order-detail-tabs">
    <b-tabs v-model="tabs.active" @change="loadTab" >

      
        
        <b-tab-item label="OVERVIEW" key="overview" :visible="isVisible(0)">
          <order-overview
            :order="order"
            :operations.sync="operations"
            ref="overview"
            v-if="isTabLoaded(0) && isVisible(0)"
          />
        </b-tab-item>

        <b-tab-item key="operations" :visible="isVisible(1)">
          <template slot="header">
            <span>ACTIVITIES [<span id="operations-count">{{ operations.length }}</span>]</span>
          </template>

          <order-operations
            :order.sync="order"
            :operations.sync="operations"
            ref="operations"
            v-if="isTabLoaded(1) && isVisible(1)"
          />
        </b-tab-item>

        <b-tab-item :label="`DOCUMENTS`" key="documents" :visible="isVisible(2)">
          <!-- <list-documents :model="order" modelType="order" :documents.sync="documents" v-if="isTabLoaded(2) && isVisible(2)"/> -->
           <div class="card is-shadowless">
            <div class="card-content">
              <file-list :model="order" modelType="order" :list-models="fileListModels" :disabled="!order.editable" v-if="isTabLoaded(2) && isVisible(2)"/>
            </div>
           </div>
        </b-tab-item>

        <b-tab-item :label="`NOTES & ACTIVITY`" key="activities" :visible="isVisible(3)">
          <order-system-activities
            :order="order"
            :activities.sync="activities"
            v-if="isTabActive(3) && isVisible(3)"
          />
        </b-tab-item>

        <b-tab-item :label="`LINKED ORDERS`" key="linked" :visible="isVisible(4)">
          <order-linked-orders
            :order="order"
            :linked-orders.sync="linkedOrders"
            @select="onSelect"
            v-if="isTabLoaded(4) && isVisible(4)"
          />
        </b-tab-item>

        <b-tab-item label="PAYMENT TIMING" key="payment-timing" :visible="isVisible(5)">
          <order-payment-timing
            :order="order"
            @select="onSelect"
            v-if="isTabLoaded(5) && isVisible(5)"
          />
        </b-tab-item>

      


    </b-tabs>



  </div>
</template>

<script>

    import OrderOverview from "./OrderOverview";
    import OrderOperations from "./OrderOperations";
    import ListDocuments from "@/components/Documents/ListDocuments";
    import OrderLinkedOrders from "./OrderLinkedOrders";
    import OrderFamilyTree from "./OrderFamilyTree";
    import OrderPaymentTiming from "./OrderPaymentTiming";
    import OrderSystemActivities from "./OrderSystemActivities";
    import FileList from "@/components/File/FileList";
    import { tabsMixin } from "@/mixins/tabsMixin";

    export default {
      props: {
        order: {
          type: Object
        },
        hidden: {
          type: Array,
          default: () => []
        },
        loaded: {
          type: Array,
          default: () => [0, 1]
        }
      },
      components: {
        OrderOverview,
        OrderOperations,
        OrderLinkedOrders,
        OrderFamilyTree,
        OrderPaymentTiming,
        OrderSystemActivities,
        ListDocuments,
        FileList
      },
      mixins: [tabsMixin],
      data: () => ({
        operations: [],
        documents: [],
        linkedOrders: [],
        activities: []
      }),
      created() {
        this.loaded.forEach(tab => this.loadTab(tab));
        // Pre-select operations tab
        if (this.$route.query.operationId) {
          this.tabs.active = 1;
        }
      },
      watch: {
        operations(operations) {
          this.$emit("update:operations", operations);
        },
        "tabs.active"(tab) {
          // if operation tab is active
          if (tab === 1) {
            this.$refs.operations.setNotesHeight();
          }
        }
      },
      methods: {
        isVisible(tab) {
          return !this.hidden.includes(tab);
        },
        onSelect(order) {
          this.$emit("select", order);
        }
      },

      computed: {

        canViewDocuments() {

          return this.$store.getters["Auth/hasPermission"]("can view documents");

        },

        navs() {

          let tabs = ['overview', 'activities'];

          tabs.push('documents');

          tabs.push('notes');

          tabs.push('linked_orders');

          tabs.push('payment_timing');

          return tabs;

        },

        fileListModels() {
          const models = [
            { id: this.order.id, type: 'order' }
          ];
          this.operations.forEach(op => models.push({ id: op.id, type: 'order_operation' }));
          return models;
        }

      }

    };

</script>

<style lang="scss">
  .order-detail-tabs .b-tabs section.tab-content  { padding: 0; }
</style>


// WEBPACK FOOTER //
// src/components/Order/OrderDetailTabs.vue